export const AUTH_LOGOUT_PATH = '/auth/logout'

export const EMAIL_VERIFICATION_POLL_INTERVAL_MS = 10_000

export const SKELETON_LOADING_DELAY_MS = 400

export const SKELETON_LOADING_DELAY_MS_WITH_CONTENT = 2000

export const GATEWAY_STATUS = {
  ONLINE: 'online',
  WARNING: 'warning',
  ERROR: 'error',
  OFFLINE: 'offline',
} as const
